export const extractYoutbeVideoId = (youtubeVideUrl: string) => {
  const pattern = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i;
  const match = youtubeVideUrl.match(pattern);
  return match && match[1];
};
